import type { ReportFreshness, SeriesPeriod } from "@nexus/widget-kit";

/**
 * `network-id-weekly` v1 — detection rows of one tenant per ISO week (Monday,
 * UTC), network group and sub-level. Weeks are chronological and gap-filled: a week with
 * no detection has `total` 0 and no groups. `partial` marks a week not fully
 * observed (cut by the period or still running).
 */
export const NETWORK_ID_WEEKLY_CONTRACT = {
  name: "network-id-weekly",
  version: 1,
} as const;

export interface NetworkIdGroupCount {
  networkGroup: string;
  networkSubLevel: string | null;
  count: number;
}

export interface NetworkIdWeek {
  /** Monday of the ISO week, `YYYY-MM-DD`. */
  weekStart: string;
  total: number;
  partial: boolean;
  groups: NetworkIdGroupCount[];
}

export interface NetworkIdWeeklyData {
  tenantId: number;
  weeks: NetworkIdWeek[];
  freshness: ReportFreshness | null;
  period?: SeriesPeriod | null;
}
